import Imgix from "react-imgix";
import FillDots from "@/Components/Svg/FillDots";
import type { RefObject } from "react";

type Props = {
    ref?: RefObject<HTMLElement | null>,
};

export default function FairShareModelSection({ ref }: Props) {
    return <section id="about" ref={ref} className="relative min-h-[560px] text-brand -mb-12 md:mb-0 md:mt-16 mask-(--mask-grid-edges-vertical) z-5">
        <FillDots width={ref?.current?.getBoundingClientRect().width ?? 0} height={ref?.current?.getBoundingClientRect().height ?? 0} density={Math.floor((ref?.current?.getBoundingClientRect().height ?? 0) / 16)} size={2} color="#F57C00" className="absolute top-0 left-0 z-0" />
        <div className="mask-(--mask-grid-edges-horizontal)">
            <div className="relative h-[100px] md:h-[200px] px-4 md:px-32 bg-linear-to-t from-lighter to-transparent">
                <div className="absolute top-0 -left-0 w-4 md:w-32 h-full border-b-2 border-brand box-content bg-lighter"></div>
                <div className="border-x-2 border-brand w-full h-full grid grid-cols-1 md:grid-cols-3 grid-rows-1 bg-">
                    <div className="hidden md:block border-r-2"></div>
                    <div className="hidden md:block"></div>
                    <div className="hidden md:block border-l-2"></div>
                </div>
                <div className="absolute top-0 -right-0 w-4 md:w-32 h-full border-b-2 border-brand box-content bg-lighter"></div>
            </div>
            <div className="relative h-[40px] md:h-[60px] px-4 md:px-32">
                <div className="absolute top-0 -left-0 w-4 md:w-32 h-full border-y-2 border-brand box-content bg-lighter"></div>
                <div className="border-t-2 border-x-2 border-brand w-full h-full grid grid-cols-1 md:grid-cols-3 grid-rows-1 bg-lighter">
                    <div className="hidden md:block border-r-2"></div>
                    <div className="hidden md:block"></div>
                    <div className="hidden md:block border-l-2"></div>
                </div>
                <div className="absolute top-0 -right-0 w-4 md:w-32 h-full border-y-2 border-brand box-content bg-lighter"></div>
            </div>

            <div className="relative h-auto md:h-[600px] px-4 md:px-32">
                <div className="absolute top-0 -left-0 w-4 md:w-32 h-full border-t-2 border-brand bg-lighter"></div>
                <div className="w-full h-full border-x-2 border-t-2 grid grid-cols-1 md:grid-cols-3 grid-rows-1">
                    <div className="border-b-2 md:border-b-0 md:border-r-2 border-brand grid grid-rows-[fit-content(66%)_1fr]">
                        <div className="border-b-2 border-brand max-w-full overflow-hidden p-4 md:p-8 flex items-center bg-lighter">
                            <h3 className="font-bold uppercase text-3xl/[2.5rem] md:text-5xl/[4rem] whitespace-break-spaces">Raw talent with no barriers.</h3>
                        </div>
                        <button className="group max-w-full overflow-hidden p-4 md:p-8 flex flex-col justify-between items-start text-left bg-lighter">
                            <span className="font-medium uppercase text-sm/[1.5rem] whitespace-break-spaces">From concept to final cut, we take care of everything between pre- and post-production.</span>
                        </button>
                    </div>
                    <div className="relative col-span-1 md:col-span-2 overflow-hidden p-4 md:p-8 bg-(image:--fade-in-square) min-h-[250px] md:min-h-0">
                        <Imgix src="https://oursharestudios.imgix.net/stock/team-01.jpg" width={1024} height={1024} imgixParams={{ q: 80, fit: 'crop', }} className="relative w-full h-full rounded object-cover object-center overflow-hidden shadow-(--shadow-edges) z-10" />
                    </div>
                </div>
                <div className="absolute top-0 -right-0 w-4 md:w-32 h-full border-t-2 border-brand bg-lighter"></div>
            </div>

            <div className="relative h-[40px] md:h-[60px] px-4 md:px-32 bg-lighter">
                <div className="absolute top-0 -left-0 w-4 md:w-32 h-full border-y-2 border-brand"></div>
                <div className="border-b-2 border-2 border-brand w-full h-full grid grid-cols-1 md:grid-cols-3 grid-rows-1">
                    <div className="hidden md:block border-r-2"></div>
                </div>
                <div className="absolute top-0 -right-0 w-4 md:w-32 h-full border-y-2 border-brand"></div>
            </div>

            <div className="relative h-[100px] md:h-[200px] px-4 md:px-32 bg-linear-to-b from-lighter to-transparent">
                <div className="border-x-2 border-brand w-full h-full grid grid-cols-1 md:grid-cols-3 grid-rows-1">
                    <div className="hidden md:block border-r-2"></div>
                    <div className="hidden md:block"></div>
                    <div className="hidden md:block border-l-2"></div>
                </div>
            </div>
        </div>
    </section>
}
